export default __webpack_public_path__ + "static/media/coresanscr15-webfont.5d20a66e.woff2";